export const useLiquidGlass = (): boolean => false;
